import { ModuleWithProviders, NgModule } from '@angular/core';
import defaultsDeep from '@df/util/fn/defaults-deep';
import { DeepPartial } from '@df/util/type/deep-partial';
import { NDfModulePaypal } from './df-module-paypal.config';

@NgModule()
export class DfModulePaypalModule {
    static forRoot(config?: DeepPartial<NDfModulePaypal.IModuleOptions>): ModuleWithProviders<DfModulePaypalModule> {
        return {
            ngModule: DfModulePaypalModule,
            providers: [
                {
                    provide: NDfModulePaypal.OPTIONS,
                    useFactory: () => {
                        return defaultsDeep(config || {}, <NDfModulePaypal.IModuleOptions>{
                            review_path: 'checkout/paypal-express-review'
                        });
                    }
                }
            ]
        };
    }
}
